import { Injectable } from '@angular/core'
import { PreviewTemplateDrawerComponent, TemplatePreviewParams } from './preview-template-drawer.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: 'root',
})
export class PreviewTemplateDrawerService {
  constructor(private dialog: DialogService) {}

  public open(params: TemplatePreviewParams) {
    return this.dialog.openDrawer(PreviewTemplateDrawerComponent, {
      data: { ...params },
      panelClass: ['drawer-full-80'],
    })
  }
}
